var React = require('react');

function OpenQuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.365821 25.6C0.365821 17.5 1.51582 11.35 3.81582 7.15C6.11582 2.95 9.91582 0.749995 15.2158 0.549992L18.0658 6.4C15.0658 6.69999 12.9658 8.14999 11.7658 10.75C10.5658 13.35 9.96582 17.55 9.96582 23.35H17.9158V40.15H0.365821V25.6ZM26.7658 25.6C26.7658 17.5 27.9158 11.35 30.2158 7.15C32.5158 2.95 36.3158 0.749995 41.6158 0.549992L44.4658 6.4C41.4658 6.69999 39.3658 8.14999 38.1658 10.75C36.9658 13.35 36.3658 17.55 36.3658 23.35H44.3158V40.15H26.7658V25.6Z","fill":"#333333"}));
}

OpenQuoteInline.defaultProps = {"width":"45","height":"41","viewBox":"0 0 45 41","fill":"none"};

module.exports = OpenQuoteInline;

OpenQuoteInline.default = OpenQuoteInline;
